import { ProviderIcon } from 'components/Custom/ProviderIcon';
import { useCountryLabel } from 'hooks/useCountryLabel';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { Organisation } from 'store/organisation/models';

export type PwaEntityBarProps = {
  organisation: Organisation;
  actions?: React.ReactNode;
};

export const PwaEntityBar: React.FC<PwaEntityBarProps> = ({
  organisation,
  actions,
}) => {
  const { t } = useTranslation();
  const { localizeCountry } = useCountryLabel();

  const entityName =
    organisation.friendlyName ||
    organisation.legalName ||
    t('common.entity');
  const providerKey = organisation.providerName?.toLowerCase?.() || '';
  const providerName = t(`common.${providerKey}`, {
    defaultValue: organisation.providerName || '',
  });
  const countryLabel = localizeCountry(
    organisation.country,
    organisation.country
  );

  return (
    <header className="pwa-topbar pwa-entity-bar" data-shell="pwa">
      <div className="pwa-topbar-row">
        <div className="pwa-row static pwa-entity-bar__identity">
          <span className="pwa-avatar" aria-hidden>
            <ProviderIcon
              providerName={organisation.providerName}
              alt=""
              width={28}
              height={28}
            />
          </span>
          <span className="pwa-row-body">
            <span className="pwa-row-title pwa-entity-bar__name">
              {entityName}
            </span>
            <span className="pwa-row-meta">
              {providerName}
              {countryLabel ? ` · ${countryLabel}` : null}
            </span>
          </span>
        </div>
        {actions}
      </div>
    </header>
  );
};

export default PwaEntityBar;
